module.exports = __webpack_public_path__ + "img/hakhak_app_3.98e60191.png";